import * as React from 'react';

/**
 * Whether the scroll container has been scrolled away from its origin on each axis. Drives the
 * pinned-column border (horizontal) and the sticky header shadow (vertical).
 */
export function useScrollShadows(scrollContainerRef: React.RefObject<HTMLDivElement | null>) {
  const [isScrolledHorizontally, setIsScrolledHorizontally] = React.useState(false);
  const [isScrolledVertically, setIsScrolledVertically] = React.useState(false);

  React.useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const update = () => {
      setIsScrolledHorizontally(container.scrollLeft > 0);
      setIsScrolledVertically(container.scrollTop > 0);
    };

    update();
    container.addEventListener('scroll', update, { passive: true });
    return () => container.removeEventListener('scroll', update);
    // The ref object is stable; its element exists from the first commit.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { isScrolledHorizontally, isScrolledVertically };
}
